import { setValueObjectByField } from '@/utils/helpers/object';

export default {
  SET_BY_FIELD: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  }
};
